// @ts-nocheck

/**
 * * `FREE` - Free Plan
 * `WEEKLY` - Weekly Subscription
 * `PREMIUM` - Premium Subscription
 * `ANNUAL` - Annual Subscription
 * `PACK_SMALL` - Small Credit Pack
 * `PACK_LARGE` - Large Credit Pack
 * `PACK_1000` - 1000 Credit Pack
 * `LIFETIME` - Lifetime Plan
 * `SOFTWARE_PACKAGE` - Software Package
 * `UNLIMITED` - Unlimited Stories
 */
export type PlanTypeEnum = typeof PlanTypeEnum[keyof typeof PlanTypeEnum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PlanTypeEnum = {
  FREE: "FREE",
  WEEKLY: "WEEKLY",
  PREMIUM: "PREMIUM",
  ANNUAL: "ANNUAL",
  PACK_SMALL: "PACK_SMALL",
  PACK_LARGE: "PACK_LARGE",
  PACK_1000: "PACK_1000",
  LIFETIME: "LIFETIME",
  SOFTWARE_PACKAGE: "SOFTWARE_PACKAGE",
  UNLIMITED: "UNLIMITED",
} as const;
